import { useEffect, useState } from "react";
import styles from "./AdminPage.module.css";

export default function AdminPage() {
  const [auth, setAuth] = useState(false);
  const [password, setPassword] = useState("");
  const [tab, setTab] = useState("apps");

  const [apps, setApps] = useState([]);
  const [channels, setChannels] = useState([]);
  const [faqs, setFaqs] = useState([]);
  const [frequencies, setFrequencies] = useState([]);
  const [software, setSoftware] = useState([]);

  const correctPassword = " ";

  useEffect(() => {
    async function loadData() {
      const fetchJSON = async (path) => {
        const res = await fetch(path);
        return res.json();
      };

      setApps(await fetchJSON("/data/apps.json"));
      setChannels(await fetchJSON("/data/channelsData.json"));
      setFaqs(await fetchJSON("/data/faq.json"));
      setFrequencies(await fetchJSON("/data/frequencies.json"));
      setSoftware(await fetchJSON("/data/software.json"));
    }

    if (auth) loadData();
  }, [auth]);

  if (!auth) {
    return (
      <div className={styles.container}>
        <h2>تسجيل الدخول</h2>
        <input
          type="password"
          placeholder="كلمة المرور"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button onClick={() => setAuth(password === correctPassword)}>دخول</button>
      </div>
    );
  }

  // حفظ البيانات إلى localStorage (يمكنك تعديلها لاحقًا لحفظ للسيرفر)
  const saveToLocal = () => {
    localStorage.setItem("apps", JSON.stringify(apps));
    localStorage.setItem("channels", JSON.stringify(channels));
    localStorage.setItem("faq", JSON.stringify(faqs));
    localStorage.setItem("frequencies", JSON.stringify(frequencies));
    localStorage.setItem("software", JSON.stringify(software));
    alert("✅ تم حفظ التعديلات في localStorage");
  };

  // ====== تبويب التطبيقات ======
  const AppsTab = () => {
    const updateAppField = (idx, field, val) => {
      setApps((prevApps) => {
        const newApps = [...prevApps];
        newApps[idx] = { ...newApps[idx], [field]: val };
        return newApps;
      });
    };

    const addApp = () => {
      setApps((prevApps) => [
        ...prevApps,
        { id: "", name: "جديد", icon: "", links: [], buttons: [] },
      ]);
    };

    const removeApp = (idx) => {
      setApps((prevApps) => prevApps.filter((_, i) => i !== idx));
    };

    return (
      <div className={styles.section}>
        <h3>📱 التطبيقات</h3>
        {apps.map((app, i) => (
          <div key={i} className={styles.item}>
            <input
              placeholder="ID"
              value={app.id}
              onChange={(e) => updateAppField(i, "id", e.target.value)}
            />
            <input
              placeholder="اسم التطبيق"
              value={app.name}
              onChange={(e) => updateAppField(i, "name", e.target.value)}
            />
            <input
              placeholder="الأيقونة"
              value={app.icon}
              onChange={(e) => updateAppField(i, "icon", e.target.value)}
            />
            {/* روابط (links) - عرض وإضافة وحذف */}
            <div className={styles.subItem}>
              <strong>الروابط (links):</strong>
              {app.links?.map((link, idx) => (
                <div key={idx} className={styles.subSubItem}>
                  <input
                    placeholder="النوع (type)"
                    value={link.type}
                    onChange={(e) => {
                      setApps((prevApps) => {
                        const newApps = [...prevApps];
                        const newLinks = [...newApps[i].links];
                        newLinks[idx] = { ...newLinks[idx], type: e.target.value };
                        newApps[i] = { ...newApps[i], links: newLinks };
                        return newApps;
                      });
                    }}
                  />
                  <input
                    placeholder="الرابط (href)"
                    value={link.href}
                    onChange={(e) => {
                      setApps((prevApps) => {
                        const newApps = [...prevApps];
                        const newLinks = [...newApps[i].links];
                        newLinks[idx] = { ...newLinks[idx], href: e.target.value };
                        newApps[i] = { ...newApps[i], links: newLinks };
                        return newApps;
                      });
                    }}
                  />
                  <button
                    onClick={() => {
                      setApps((prevApps) => {
                        const newApps = [...prevApps];
                        const newLinks = [...newApps[i].links];
                        newLinks.splice(idx, 1);
                        newApps[i] = { ...newApps[i], links: newLinks };
                        return newApps;
                      });
                    }}
                  >
                    حذف رابط
                  </button>
                </div>
              ))}
              <button
                onClick={() => {
                  setApps((prevApps) => {
                    const newApps = [...prevApps];
                    const newLinks = [...(newApps[i].links || [])];
                    newLinks.push({ type: "", href: "" });
                    newApps[i] = { ...newApps[i], links: newLinks };
                    return newApps;
                  });
                }}
              >
                ➕ إضافة رابط
              </button>
            </div>

            {/* أزرار (buttons) */}
            <div className={styles.subItem}>
              <strong>الأزرار (buttons):</strong>
              {app.buttons?.map((btn, idx) => (
                <div key={idx} className={styles.subSubItem}>
                  <input
                    placeholder="النص"
                    value={btn.text}
                    onChange={(e) => {
                      setApps((prevApps) => {
                        const newApps = [...prevApps];
                        const newBtns = [...newApps[i].buttons];
                        newBtns[idx] = { ...newBtns[idx], text: e.target.value };
                        newApps[i] = { ...newApps[i], buttons: newBtns };
                        return newApps;
                      });
                    }}
                  />
                  <input
                    placeholder="الكود"
                    value={btn.code}
                    onChange={(e) => {
                      setApps((prevApps) => {
                        const newApps = [...prevApps];
                        const newBtns = [...newApps[i].buttons];
                        newBtns[idx] = { ...newBtns[idx], code: e.target.value };
                        newApps[i] = { ...newApps[i], buttons: newBtns };
                        return newApps;
                      });
                    }}
                  />
                  <input
                    placeholder="النوع (type)"
                    value={btn.type}
                    onChange={(e) => {
                      setApps((prevApps) => {
                        const newApps = [...prevApps];
                        const newBtns = [...newApps[i].buttons];
                        newBtns[idx] = { ...newBtns[idx], type: e.target.value };
                        newApps[i] = { ...newApps[i], buttons: newBtns };
                        return newApps;
                      });
                    }}
                  />
                  <button
                    onClick={() => {
                      setApps((prevApps) => {
                        const newApps = [...prevApps];
                        const newBtns = [...newApps[i].buttons];
                        newBtns.splice(idx, 1);
                        newApps[i] = { ...newApps[i], buttons: newBtns };
                        return newApps;
                      });
                    }}
                  >
                    حذف زر
                  </button>
                </div>
              ))}
              <button
                onClick={() => {
                  setApps((prevApps) => {
                    const newApps = [...prevApps];
                    const newBtns = [...(newApps[i].buttons || [])];
                    newBtns.push({ text: "", code: "", type: "" });
                    newApps[i] = { ...newApps[i], buttons: newBtns };
                    return newApps;
                  });
                }}
              >
                ➕ إضافة زر
              </button>
            </div>

            <button onClick={() => removeApp(i)}>🗑️ حذف التطبيق</button>
            <hr />
          </div>
        ))}
        <button onClick={addApp}>➕ إضافة تطبيق جديد</button>
      </div>
    );
  };

  // ====== تبويب القنوات ======
  const ChannelsTab = () => {
    const updateChannelField = (idx, field, val) => {
      setChannels((prev) => {
        const newCh = [...prev];
        newCh[idx] = { ...newCh[idx], [field]: val };
        return newCh;
      });
    };

    const addChannel = () => {
      setChannels((prev) => [
        ...prev,
        { id: Date.now(), name: "", tags: [], url: "", logo: "" },
      ]);
    };

    const removeChannel = (idx) => {
      setChannels((prev) => prev.filter((_, i) => i !== idx));
    };

    const updateTag = (chIdx, tagIdx, val) => {
      setChannels((prev) => {
        const newCh = [...prev];
        const newTags = [...(newCh[chIdx].tags || [])];
        newTags[tagIdx] = val;
        newCh[chIdx] = { ...newCh[chIdx], tags: newTags };
        return newCh;
      });
    };

    const addTag = (chIdx) => {
      setChannels((prev) => {
        const newCh = [...prev];
        const newTags = [...(newCh[chIdx].tags || [])];
        newTags.push("");
        newCh[chIdx] = { ...newCh[chIdx], tags: newTags };
        return newCh;
      });
    };

    const removeTag = (chIdx, tagIdx) => {
      setChannels((prev) => {
        const newCh = [...prev];
        const newTags = [...(newCh[chIdx].tags || [])];
        newTags.splice(tagIdx, 1);
        newCh[chIdx] = { ...newCh[chIdx], tags: newTags };
        return newCh;
      });
    };

    return (
      <div className={styles.section}>
        <h3>📺 القنوات</h3>
        {channels.map((ch, i) => (
          <div key={i} className={styles.item}>
            <input
              placeholder="ID"
              type="number"
              value={ch.id}
              onChange={(e) => updateChannelField(i, "id", +e.target.value)}
            />
            <input
              placeholder="اسم القناة"
              value={ch.name}
              onChange={(e) => updateChannelField(i, "name", e.target.value)}
            />
            <input
              placeholder="الرابط (URL)"
              value={ch.url}
              onChange={(e) => updateChannelField(i, "url", e.target.value)}
            />
            <input
              placeholder="شعار القناة (logo)"
              value={ch.logo}
              onChange={(e) => updateChannelField(i, "logo", e.target.value)}
            />

            <div className={styles.subItem}>
              <strong>التصنيفات (tags):</strong>
              {ch.tags?.map((tag, idx) => (
                <div key={idx} className={styles.subSubItem}>
                  <input
                    placeholder="تصنيف"
                    value={tag}
                    onChange={(e) => updateTag(i, idx, e.target.value)}
                  />
                  <button onClick={() => removeTag(i, idx)}>حذف تصنيف</button>
                </div>
              ))}
              <button onClick={() => addTag(i)}>➕ إضافة تصنيف</button>
            </div>

            <button onClick={() => removeChannel(i)}>🗑️ حذف القناة</button>
            <hr />
          </div>
        ))}
        <button onClick={addChannel}>➕ إضافة قناة جديدة</button>
      </div>
    );
  };

  // ====== تبويب الأسئلة (FAQ) ======
  const FaqTab = () => {
    const updateFaqField = (idx, field, val) => {
      setFaqs((prev) => {
        const newFaqs = [...prev];
        if (field === "question") {
          newFaqs[idx] = { ...newFaqs[idx], question: val };
        } else if (field.startsWith("answer.")) {
          const ansField = field.split(".")[1];
          newFaqs[idx] = {
            ...newFaqs[idx],
            answer: {
              ...newFaqs[idx].answer,
              [ansField]: val,
            },
          };
        }
        return newFaqs;
      });
    };

    const updateAnswerLink = (idx, linkField, val) => {
      setFaqs((prev) => {
        const newFaqs = [...prev];
        const currentAnswer = newFaqs[idx].answer || {};
        newFaqs[idx] = {
          ...newFaqs[idx],
          answer: {
            ...currentAnswer,
            link: {
              ...((currentAnswer.link) || {}),
              [linkField]: val,
            },
          },
        };
        return newFaqs;
      });
    };

    const addFaq = () => {
      setFaqs((prev) => [
        ...prev,
        {
          question: "",
          answer: { text: "", link: { text: "", url: "" } },
        },
      ]);
    };

    const removeFaq = (idx) => {
      setFaqs((prev) => prev.filter((_, i) => i !== idx));
    };

    return (
      <div className={styles.section}>
        <h3>❓ الأسئلة</h3>
        {faqs.map((faq, i) => (
          <div key={i} className={styles.item}>
            <input
              placeholder="السؤال"
              value={faq.question}
              onChange={(e) => updateFaqField(i, "question", e.target.value)}
            />
            <textarea
              placeholder="الجواب"
              rows={3}
              value={faq.answer?.text || ""}
              onChange={(e) => updateFaqField(i, "answer.text", e.target.value)}
            />
            <input
              placeholder="نص الرابط"
              value={faq.answer?.link?.text || ""}
              onChange={(e) => updateAnswerLink(i, "text", e.target.value)}
            />
            <input
              placeholder="رابط"
              value={faq.answer?.link?.url || ""}
              onChange={(e) => updateAnswerLink(i, "url", e.target.value)}
            />
            <button onClick={() => removeFaq(i)}>🗑️ حذف السؤال</button>
            <hr />
          </div>
        ))}
        <button onClick={addFaq}>➕ إضافة سؤال جديد</button>
      </div>
    );
  };

  // ====== تبويب الترددات ======
  const FrequenciesTab = () => {
    // الترددات لديك هي كائن، يحتوي على packages: []
    // لذلك نقوم بتعديل حقل كل باقة، والأقمار، والترددات داخلها
    const updatePackageField = (pkgIdx, field, val) => {
      setFrequencies((prev) => {
        const newFreq = { ...prev };
        newFreq.packages = [...newFreq.packages];
        newFreq.packages[pkgIdx] = {
          ...newFreq.packages[pkgIdx],
          [field]: val,
        };
        return newFreq;
      });
    };

    const addPackage = () => {
      setFrequencies((prev) => {
        const newFreq = { ...prev };
        newFreq.packages = [...(newFreq.packages || [])];
        newFreq.packages.push({
          name: "",
          satellites: [],
        });
        return newFreq;
      });
    };

    const removePackage = (pkgIdx) => {
      setFrequencies((prev) => {
        const newFreq = { ...prev };
        newFreq.packages = [...(newFreq.packages || [])];
        newFreq.packages.splice(pkgIdx, 1);
        return newFreq;
      });
    };

    // الأقمار داخل باقة
    const updateSatelliteField = (pkgIdx, satIdx, field, val) => {
      setFrequencies((prev) => {
        const newFreq = { ...prev };
        newFreq.packages = [...(newFreq.packages || [])];
        const newSats = [...(newFreq.packages[pkgIdx].satellites || [])];
        newSats[satIdx] = {
          ...newSats[satIdx],
          [field]: val,
        };
        newFreq.packages[pkgIdx] = {
          ...newFreq.packages[pkgIdx],
          satellites: newSats,
        };
        return newFreq;
      });
    };

    const addSatellite = (pkgIdx) => {
      setFrequencies((prev) => {
        const newFreq = { ...prev };
        newFreq.packages = [...(newFreq.packages || [])];
        const newSats = [...(newFreq.packages[pkgIdx].satellites || [])];
        newSats.push({
          name: "",
          frequencies: [],
        });
        newFreq.packages[pkgIdx] = {
          ...newFreq.packages[pkgIdx],
          satellites: newSats,
        };
        return newFreq;
      });
    };

    const removeSatellite = (pkgIdx, satIdx) => {
      setFrequencies((prev) => {
        const newFreq = { ...prev };
        newFreq.packages = [...(newFreq.packages || [])];
        const newSats = [...(newFreq.packages[pkgIdx].satellites || [])];
        newSats.splice(satIdx, 1);
        newFreq.packages[pkgIdx] = {
          ...newFreq.packages[pkgIdx],
          satellites: newSats,
        };
        return newFreq;
      });
    };

    // الترددات داخل القمر
    const updateFrequencyField = (pkgIdx, satIdx, freqIdx, field, val) => {
      setFrequencies((prev) => {
        const newFreq = { ...prev };
        newFreq.packages = [...(newFreq.packages || [])];
        const newSats = [...(newFreq.packages[pkgIdx].satellites || [])];
        const newFreqs = [...(newSats[satIdx].frequencies || [])];
        newFreqs[freqIdx] = {
          ...newFreqs[freqIdx],
          [field]: val,
        };
        newSats[satIdx] = {
          ...newSats[satIdx],
          frequencies: newFreqs,
        };
        newFreq.packages[pkgIdx] = {
          ...newFreq.packages[pkgIdx],
          satellites: newSats,
        };
        return newFreq;
      });
    };

    const addFrequency = (pkgIdx, satIdx) => {
      setFrequencies((prev) => {
        const newFreq = { ...prev };
        newFreq.packages = [...(newFreq.packages || [])];
        const newSats = [...(newFreq.packages[pkgIdx].satellites || [])];
        const newFreqs = [...(newSats[satIdx].frequencies || [])];
        newFreqs.push({
          frequency: "",
          polarization: "",
          symbol_rate: "",
          fec: "",
          channels: [],
        });
        newSats[satIdx] = {
          ...newSats[satIdx],
          frequencies: newFreqs,
        };
        newFreq.packages[pkgIdx] = {
          ...newFreq.packages[pkgIdx],
          satellites: newSats,
        };
        return newFreq;
      });
    };

    const removeFrequency = (pkgIdx, satIdx, freqIdx) => {
      setFrequencies((prev) => {
        const newFreq = { ...prev };
        newFreq.packages = [...(newFreq.packages || [])];
        const newSats = [...(newFreq.packages[pkgIdx].satellites || [])];
        const newFreqs = [...(newSats[satIdx].frequencies || [])];
        newFreqs.splice(freqIdx, 1);
        newSats[satIdx] = {
          ...newSats[satIdx],
          frequencies: newFreqs,
        };
        newFreq.packages[pkgIdx] = {
          ...newFreq.packages[pkgIdx],
          satellites: newSats,
        };
        return newFreq;
      });
    };

    // قنوات داخل تردد
    const updateChannelInFrequency = (pkgIdx, satIdx, freqIdx, chIdx, val) => {
      setFrequencies((prev) => {
        const newFreq = { ...prev };
        newFreq.packages = [...(newFreq.packages || [])];
        const newSats = [...(newFreq.packages[pkgIdx].satellites || [])];
        const newFreqs = [...(newSats[satIdx].frequencies || [])];
        const newChannels = [...(newFreqs[freqIdx].channels || [])];
        newChannels[chIdx] = val;
        newFreqs[freqIdx] = {
          ...newFreqs[freqIdx],
          channels: newChannels,
        };
        newSats[satIdx] = {
          ...newSats[satIdx],
          frequencies: newFreqs,
        };
        newFreq.packages[pkgIdx] = {
          ...newFreq.packages[pkgIdx],
          satellites: newSats,
        };
        return newFreq;
      });
    };

    const addChannelInFrequency = (pkgIdx, satIdx, freqIdx) => {
      setFrequencies((prev) => {
        const newFreq = { ...prev };
        newFreq.packages = [...(newFreq.packages || [])];
        const newSats = [...(newFreq.packages[pkgIdx].satellites || [])];
        const newFreqs = [...(newSats[satIdx].frequencies || [])];
        const newChannels = [...(newFreqs[freqIdx].channels || [])];
        newChannels.push("");
        newFreqs[freqIdx] = {
          ...newFreqs[freqIdx],
          channels: newChannels,
        };
        newSats[satIdx] = {
          ...newSats[satIdx],
          frequencies: newFreqs,
        };
        newFreq.packages[pkgIdx] = {
          ...newFreq.packages[pkgIdx],
          satellites: newSats,
        };
        return newFreq;
      });
    };

    const removeChannelInFrequency = (pkgIdx, satIdx, freqIdx, chIdx) => {
      setFrequencies((prev) => {
        const newFreq = { ...prev };
        newFreq.packages = [...(newFreq.packages || [])];
        const newSats = [...(newFreq.packages[pkgIdx].satellites || [])];
        const newFreqs = [...(newSats[satIdx].frequencies || [])];
        const newChannels = [...(newFreqs[freqIdx].channels || [])];
        newChannels.splice(chIdx, 1);
        newFreqs[freqIdx] = {
          ...newFreqs[freqIdx],
          channels: newChannels,
        };
        newSats[satIdx] = {
          ...newSats[satIdx],
          frequencies: newFreqs,
        };
        newFreq.packages[pkgIdx] = {
          ...newFreq.packages[pkgIdx],
          satellites: newSats,
        };
        return newFreq;
      });
    };

    return (
      <div className={styles.section}>
        <h3>📡 الترددات</h3>
        {(frequencies.packages || []).map((pkg, pkgIdx) => (
          <div key={pkgIdx} className={styles.item}>
            <input
              placeholder="اسم الباقة"
              value={pkg.name}
              onChange={(e) => updatePackageField(pkgIdx, "name", e.target.value)}
            />
            <button onClick={() => removePackage(pkgIdx)}>🗑️ حذف باقة</button>

            <div className={styles.subItem}>
              <strong>الأقمار الصناعية:</strong>
              {(pkg.satellites || []).map((sat, satIdx) => (
                <div key={satIdx} className={styles.subSubItem}>
                  <input
                    placeholder="اسم القمر الصناعي"
                    value={sat.name}
                    onChange={(e) =>
                      updateSatelliteField(pkgIdx, satIdx, "name", e.target.value)
                    }
                  />
                  <button onClick={() => removeSatellite(pkgIdx, satIdx)}>
                    🗑️ حذف قمر
                  </button>

                  <div className={styles.subSubSubItem}>
                    <strong>الترددات:</strong>
                    {(sat.frequencies || []).map((freq, freqIdx) => (
                      <div key={freqIdx} className={styles.subSubSubItem}>
                        <input
                          placeholder="التردد"
                          value={freq.frequency}
                          onChange={(e) =>
                            updateFrequencyField(
                              pkgIdx,
                              satIdx,
                              freqIdx,
                              "frequency",
                              e.target.value
                            )
                          }
                        />
                        <input
                          placeholder="الاستقطاب"
                          value={freq.polarization}
                          onChange={(e) =>
                            updateFrequencyField(
                              pkgIdx,
                              satIdx,
                              freqIdx,
                              "polarization",
                              e.target.value
                            )
                          }
                        />
                        <input
                          placeholder="معدل الترميز"
                          value={freq.symbol_rate}
                          onChange={(e) =>
                            updateFrequencyField(
                              pkgIdx,
                              satIdx,
                              freqIdx,
                              "symbol_rate",
                              e.target.value
                            )
                          }
                        />
                        <input
                          placeholder="FEC"
                          value={freq.fec}
                          onChange={(e) =>
                            updateFrequencyField(
                              pkgIdx,
                              satIdx,
                              freqIdx,
                              "fec",
                              e.target.value
                            )
                          }
                        />

                        <div className={styles.subSubSubSubItem}>
                          <strong>القنوات:</strong>
                          {(freq.channels || []).map((channelName, chIdx) => (
                            <div key={chIdx} className={styles.subSubSubSubItem}>
                              <input
                                placeholder="اسم القناة"
                                value={channelName}
                                onChange={(e) =>
                                  updateChannelInFrequency(
                                    pkgIdx,
                                    satIdx,
                                    freqIdx,
                                    chIdx,
                                    e.target.value
                                  )
                                }
                              />
                              <button
                                onClick={() =>
                                  removeChannelInFrequency(pkgIdx, satIdx, freqIdx, chIdx)
                                }
                              >
                                حذف قناة
                              </button>
                            </div>
                          ))}
                          <button onClick={() => addChannelInFrequency(pkgIdx, satIdx, freqIdx)}>
                            ➕ إضافة قناة
                          </button>
                        </div>

                        <button
                          onClick={() => removeFrequency(pkgIdx, satIdx, freqIdx)}
                          style={{ marginTop: "10px" }}
                        >
                          🗑️ حذف التردد
                        </button>
                        <hr />
                      </div>
                    ))}
                    <button onClick={() => addFrequency(pkgIdx, satIdx)}>➕ إضافة تردد</button>
                  </div>
                  <hr />
                </div>
              ))}
              <button onClick={() => addSatellite(pkgIdx)}>➕ إضافة قمر صناعي</button>
            </div>
            <hr />
          </div>
        ))}
        <button onClick={addPackage}>➕ إضافة باقة جديدة</button>
      </div>
    );
  };

  // ====== تبويب البرامج ======
  const SoftwareTab = () => {
    const updateSoftwareField = (idx, field, val) => {
      setSoftware((prev) => {
        const newSoft = [...prev];
        newSoft[idx] = { ...newSoft[idx], [field]: val };
        return newSoft;
      });
    };

    const updateUpdateField = (softIdx, updIdx, field, val) => {
      setSoftware((prev) => {
        const newSoft = [...prev];
        const softItem = { ...newSoft[softIdx] };
        const newUpdates = [...(softItem.updates || [])];
        newUpdates[updIdx] = { ...newUpdates[updIdx], [field]: val };
        softItem.updates = newUpdates;
        newSoft[softIdx] = softItem;
        return newSoft;
      });
    };

    const addSoftware = () => {
      setSoftware((prev) => [
        ...prev,
        { id: "", company: "", image: "", name: "", updates: [] },
      ]);
    };

    const removeSoftware = (idx) => {
      setSoftware((prev) => prev.filter((_, i) => i !== idx));
    };

    const addUpdate = (softIdx) => {
      setSoftware((prev) => {
        const newSoft = [...prev];
        const softItem = { ...newSoft[softIdx] };
        const newUpdates = [...(softItem.updates || [])];
        newUpdates.push({
          serverVersion: "",
          releaseDate: "",
          versionNumber: "",
          downloadUrl: "",
        });
        softItem.updates = newUpdates;
        newSoft[softIdx] = softItem;
        return newSoft;
      });
    };

    const removeUpdate = (softIdx, updIdx) => {
      setSoftware((prev) => {
        const newSoft = [...prev];
        const softItem = { ...newSoft[softIdx] };
        const newUpdates = [...(softItem.updates || [])];
        newUpdates.splice(updIdx, 1);
        softItem.updates = newUpdates;
        newSoft[softIdx] = softItem;
        return newSoft;
      });
    };

    return (
      <div className={styles.section}>
        <h3>💽 البرامج</h3>
        {software.map((soft, i) => (
          <div key={i} className={styles.item}>
            <input
              placeholder="ID"
              value={soft.id}
              onChange={(e) => updateSoftwareField(i, "id", e.target.value)}
            />
            <input
              placeholder="الشركة"
              value={soft.company}
              onChange={(e) => updateSoftwareField(i, "company", e.target.value)}
            />
            <input
              placeholder="الصورة"
              value={soft.image}
              onChange={(e) => updateSoftwareField(i, "image", e.target.value)}
            />
            <input
              placeholder="اسم البرنامج"
              value={soft.name}
              onChange={(e) => updateSoftwareField(i, "name", e.target.value)}
            />

            <div className={styles.subItem}>
              <strong>التحديثات:</strong>
              {soft.updates?.map((upd, idx) => (
                <div key={idx} className={styles.subSubItem}>
                  <input
                    placeholder="إصدار السيرفر"
                    value={upd.serverVersion}
                    onChange={(e) =>
                      updateUpdateField(i, idx, "serverVersion", e.target.value)
                    }
                  />
                  <input
                    placeholder="تاريخ الإصدار"
                    value={upd.releaseDate}
                    onChange={(e) =>
                      updateUpdateField(i, idx, "releaseDate", e.target.value)
                    }
                  />
                  <input
                    placeholder="رقم الإصدار"
                    value={upd.versionNumber}
                    onChange={(e) =>
                      updateUpdateField(i, idx, "versionNumber", e.target.value)
                    }
                  />
                  <input
                    placeholder="رابط التحميل"
                    value={upd.downloadUrl}
                    onChange={(e) =>
                      updateUpdateField(i, idx, "downloadUrl", e.target.value)
                    }
                  />
                  <button onClick={() => removeUpdate(i, idx)}>🗑️ حذف تحديث</button>
                </div>
              ))}
              <button onClick={() => addUpdate(i)}>➕ إضافة تحديث</button>
            </div>

            <button onClick={() => removeSoftware(i)}>🗑️ حذف برنامج</button>
            <hr />
          </div>
        ))}
        <button onClick={addSoftware}>➕ إضافة برنامج جديد</button>
      </div>
    );
  };

  return (
    <div className={styles.container}>
      <h2>لوحة الإدارة</h2>
      <div className={styles.tabs}>
        <button
          className={tab === "apps" ? styles.active : ""}
          onClick={() => setTab("apps")}
        >
          📱 التطبيقات
        </button>
        <button
          className={tab === "channels" ? styles.active : ""}
          onClick={() => setTab("channels")}
        >
          📺 القنوات
        </button>
        <button
          className={tab === "faq" ? styles.active : ""}
          onClick={() => setTab("faq")}
        >
          ❓ الأسئلة
        </button>
        <button
          className={tab === "frequencies" ? styles.active : ""}
          onClick={() => setTab("frequencies")}
        >
          📡 الترددات
        </button>
        <button
          className={tab === "software" ? styles.active : ""}
          onClick={() => setTab("software")}
        >
          💽 البرامج
        </button>
        <button onClick={saveToLocal}>💾 حفظ</button>
      </div>

      {tab === "apps" && <AppsTab />}
      {tab === "channels" && <ChannelsTab />}
      {tab === "faq" && <FaqTab />}
      {tab === "frequencies" && <FrequenciesTab />}
      {tab === "software" && <SoftwareTab />}
    </div>
  );
}
